import { useState, useEffect } from 'react';
import { Textarea, Label } from '../../../../../styles/component.styles.jsx';

const ParagraphSection = ({ initialContent = {}, initialMetadata = {}, onChange }) => {
  const [text, setText] = useState(initialContent?.text || '');

  useEffect(() => {
    onChange({ content: { text }, metadata: {} });
  }, [text]);

  return (
    <>
      <Label>Paragraph Text</Label>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Enter paragraph..." />
    </>
  );
};

export default ParagraphSection;